/** @jsxImportSource @emotion/react */
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import t from "../../theme";

// Matches the full language set Termly's own in-page switcher offers for
// this account — verified via the `lang` query param against the live
// policy viewer (codes outside this set silently fall back to English).
export const POLICY_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "pt-br", label: "Português (Brasil)" },
  { code: "nl", label: "Nederlands" },
  { code: "da", label: "Dansk" },
  { code: "fi", label: "Suomi" },
  { code: "sv", label: "Svenska" },
  { code: "no", label: "Norsk" },
  { code: "pl", label: "Polski" },
  { code: "hu", label: "Magyar" },
  { code: "tr", label: "Türkçe" },
  { code: "el", label: "Ελληνικά" },
];

const styles = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: t.radius.pill,
    background: t.glass.primary,
    backdropFilter: t.blur.medium,
    WebkitBackdropFilter: t.blur.medium,
    border: `1px solid ${t.green.border}`,
    boxShadow: t.shadow.sm,
    transition: t.transition.fast,
    "&:hover": {
      borderColor: t.green.borderSelected,
      boxShadow: t.shadow.md,
    },
    "&:focus-within": {
      borderColor: t.green.borderSelected,
      boxShadow: t.shadow.brandFocus,
    },
  },
  icon: {
    fontSize: "20px",
    color: t.green.solid,
    flexShrink: 0,
  },
  select: {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    border: "none",
    background: "transparent",
    color: t.text.primary,
    fontFamily: t.font.family,
    fontSize: "0.9rem",
    fontWeight: 600,
    cursor: "pointer",
    outline: "none",
    padding: "0 20px 0 0",
  },
  arrow: {
    fontSize: "18px",
    color: t.text.muted,
    marginLeft: "-20px",
    pointerEvents: "none",
    flexShrink: 0,
  },
};

const PolicyLanguageSelect = ({ value, onChange }) => (
  <div css={styles.wrapper}>
    <LanguageIcon css={styles.icon} />
    <select
      aria-label="Select policy language"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      css={styles.select}
    >
      {POLICY_LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
    <KeyboardArrowDownIcon css={styles.arrow} />
  </div>
);

export default PolicyLanguageSelect;
